import React, { FC } from 'react';
import { Redirect, Route, useRouteMatch } from 'react-router-dom';
import ContainerPage from '../../pages/container/container';
import { authService } from '../../utils/services/auth-service';


interface IPrivateRouteProps {
  redirectPath?: string;
  exact?: boolean;
  component: React.ElementType;
  path: string | undefined;
}

interface IRouteParams {
  id: string;
}

const PrivateRoute: FC<IPrivateRouteProps> = ({
  component: Component,
  ...props
}): JSX.Element => {

  const { path } = props;
  const computedMatch = useRouteMatch<IRouteParams>(path || '');

  const id = computedMatch?.params?.id || '';
  const urlPath: string = id ? `/presentation/${id}` : '/404';

  return (
    <Route {...props}>
      {authService.isAuth(id)
        ? <ContainerPage urlPath={urlPath}>
          <Component/>
        </ContainerPage>
        : <Redirect to={urlPath}/>
      }
    </Route>
  );
};

export default PrivateRoute;
